'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    root: {
        fontSize: variables.SIZES.TEXT_MEDIUM,
        fontWeight: variables.WEIGHTS.MEDIUM,
        textTransform: "none",
        minWidth: "auto",
        boxSizing: "border-box",
        "&:hover": {
            borderBottom: `2px solid ${variables.COLORS.GREYSCALE_80}`,
            paddingBottom: "4px",
        },
        "&.sprout-focus-visible": {
            boxShadow: `inset 0 0 0 2px ${variables.COLORS.MISC_FOCUS_BORDER}`,
            paddingTop: "4px",
            backgroundColor: variables.COLORS.GREYSCALE_0_03,
            borderRadius: variables.SIZES.BORDER_RADIUS,
            minHeight: "44px",
            paddingBottom: "4px",
            border: "none",
        },
        "&$disabled": {
            opacity: 0.3,
        },
    },
    textColorPrimary: {
        color: variables.COLORS.GREYSCALE_25,
        "&$selected": {
            color: variables.COLORS.GREYSCALE_25,
        },
    },
    textColorInherit: {
        opacity: "unset",
    },
    fullWidth: {
        "&.sprout-focus-visible": {
            paddingRight: 12,
            paddingLeft: 12,
        },
    },
    wrapper: {
        alignItems: "initial",
    },
    labelIcon: {
        minWidth: "40px",
        minHeight: "48px",
        "&.sprout-focus-visible": {
            minHeight: "auto",
            height: "30px",
            marginTop: 9,
            marginBottom: 9,
            flexDirection: "column",
            paddingRight: "12px",
            paddingBottom: "2px",
        },
        "& $wrapper": {
            display: "block",
        },
    },
};

var MuiTab = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiTab = MuiTab;
exports.light = light;
